const THEME_STORAGE_KEY = '4ge-theme'

export const THEMES = [
    { value: 'dark', label: 'Dark (Forge)' },
    { value: 'light', label: 'Light (Studio)' },
    { value: 'tokyo-after-dark', label: 'Tokyo After Dark' },
]

export function getStoredTheme() {
    if (typeof window === 'undefined') return 'dark'
    const stored = window.localStorage.getItem(THEME_STORAGE_KEY)
    const isValid = THEMES.some((theme) => theme.value === stored)
    return isValid ? stored : 'dark'
}

export function applyTheme(theme) {
    const isValid = THEMES.some((item) => item.value === theme)
    const next = isValid ? theme : 'dark'
    if (typeof document !== 'undefined') {
        document.documentElement.dataset.theme = next
    }
    if (typeof window !== 'undefined') {
        window.localStorage.setItem(THEME_STORAGE_KEY, next)
    }
    return next
}
